import block from './block.json';

export const headingThemeAttributes = {
	h2: {
		color: '@tokens.variants.default.titleColor',
		typography: '@tokens.typographies.heading-2',
		textAlignment: 'left',
	},
	h3: {
		color: '@tokens.variants.default.titleColor',
		typography: '@tokens.typographies.heading-3',
		textAlignment: 'left',
	},
	h4: {
		color: '@tokens.variants.default.titleColor',
		typography: '@tokens.typographies.heading-4',
		textAlignment: 'left',
	},
};

export const HeadingThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: headingThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
